export const CONTINUE_CREDIT_APP = "CONTINUE_CREDIT_APP";
export type CONTINUE_CREDIT_APP = "CONTINUE_CREDIT_APP";

export const GO_BACK_CREDIT_APP = "GO_BACK_CREDIT_APP";
export type GO_BACK_CREDIT_APP = "GO_BACK_CREDIT_APP";

export const SKIP_CREDIT_APP = "SKIP_CREDIT_APP";
export type SKIP_CREDIT_APP = "SKIP_CREDIT_APP";

export const SET_COSIGNER_QUESTION = "SET_COSIGNER_QUESTION";
export type SET_COSIGNER_QUESTION = "SET_COSIGNER_QUESTION";

export const SET_CREDIT_APPLICATION_ID = "SET_CREDIT_APPLICATION_ID";
export type SET_CREDIT_APPLICATION_ID = "SET_CREDIT_APPLICATION_ID";

export const RESET_CREDIT_APP = "RESET_CREDIT_APP";
export type RESET_CREDIT_APP = "RESET_CREDIT_APP";
